export const GPS = { priceNetto: 39.0, priceBrutto: 45.0 }
export const FUEL_CARD = { priceNetto: 10.0, priceBrutto: 12.3 }
